/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.masterTools").
controller("DxBulkDeleteUserRouteController", function BulkDeleteUserRouteController(
	$http,
	$interval,

	validationService,
	dxApi,
	dxDialog,

	ngPasteFromErrors
) {
	"use strict";

	var self = this;

	self.emailsAndIds = [];
	self.users = [];
	self.errors = [];
	self.emailsValidated = false;
	self.idsValidated = false;
	self.deletionDone = false;
	self.loading = false;

	var ids = [];
	var emails = [];

	var numberOfRows = 0;
	var rowValidationCounter = 0;

	var jobInterval = null;

	self.onBeforePaste = function onBeforePaste(data) {
		self.emailsAndIds = [];
		self.users = [];
		self.errors = [];
		self.emailsValidated = false;
		self.idsValidated = false;
		self.deletionDone = false;
		self.loading = false;
		self.job = null;

		ids = [];
		emails = [];

		rowValidationCounter = 0;
		numberOfRows = data.split(/\r\n|\r|\n/).length;
		return data;
	};

	self.onValidateEntry = function onValidateEntry(row) {
		var emailOrId = row.emailOrId.trim();

		if (emailOrIdInList(emailOrId)) {
			incrementValidationCounter();
			return false;
		}

		if (isNumber(emailOrId)) {
			ids.push(emailOrId);
		} else if (isEmail(emailOrId)) {
			emails.push(emailOrId);
		} else {
			self.errors.push("Not a valid e-mail or user id: " + emailOrId);
			incrementValidationCounter();
			return false;
		}

		incrementValidationCounter();
		return true;
	};

	self.onEntryError = function onEntryError(error, rowData) {
		if (error === ngPasteFromErrors.invalidColumnLength) {
			var expectedColumns = rowData.expectedLength + " column" + (rowData.expectedLength > 1 ? "s" : "");
			return self.errors.push("Expected row " + (rowData.index + 1) + " to be " + expectedColumns + ", but it was " + rowData.actualLength + ": " + rowData.source);
		}

		return null;
	};

	self.bulkDeleteUsers = function bulkDeleteUsers() {
		dxDialog.confirm({
			title: "Delete users",
			body: "Are you sure you want to GDPR delete these users?",
			acceptText: "Delete",
			acceptCallback: runDelete,
			rejectText: "Cancel",
		});

		function runDelete() {
			self.errors = [];
			self.emailsValidated = false;
			self.idsValidated = false;

			var url = "/api/v1/users?userIds=";

			for (var i = 0; i < self.users.length; i++) {
				url += self.users[i].id;

				if (i !== self.users.length - 1) {
					url += ",";
				}
			}

			self.users = [];
			dxDialog.closeMostRecent();
			self.loading = true;

			return $http.delete(url).then(function success(resp) {
				self.job = resp.data;
				jobInterval = $interval(pollJob, 1000);
			}, function fail(resp) {
				self.loading = false;
				self.errors.push("Could not perform the GDPR delete request: " + resp.data.message);
			});
		}
	};

	function pollJob() {
		dxApi.v1.jobs.get(self.job.id).then(function success(resp) {
			self.job = resp.data;

			if (self.job.taskCountDone === self.job.taskCountTotal) {
				self.deletionDone = true;
				self.loading = false;
				if (jobInterval !== null) {
					$interval.cancel(jobInterval);
					jobInterval = null;
				}
			}
		}, function fail(resp) {
			self.loading = false;
			if (jobInterval !== null) {
				$interval.cancel(jobInterval);
				jobInterval = null;
			}
			self.errors.push("Could not get job: " + resp.data.message);
		});
	}

	function getUsers() {
		if (emails.length > 0 || ids.length > 0) {
			self.loading = true;
		}

		if (emails.length > 0) {
			dxApi.v1.users.get(null, emails).then(function success(data) {
				identifyNonExistentEmails(data);
				addUsers(data);
				self.loading = false;
			}, function fail(resp) {
				if (resp.status === 404) {
					self.errors.push("Could not find any users with the emails: " + emails.join(", "));
				} else {
					self.errors.push("Could not complete user email query: " + resp.error.message);
				}
			}).finally(function done() {
				self.emailsValidated = true;
				if (self.idsValidated) {
					self.loading = false;
				}
			});
		} else {
			self.emailsValidated = true;
		}

		if (ids.length > 0) {
			dxApi.v1.users.get(ids, null).then(function success(data) {
				identifyNonExistentIds(data);
				addUsers(data);
				self.loading = false;
			}, function fail(resp) {
				if (resp.status === 404) {
					self.errors.push("Could not find any users with the ids: " + ids.join(", "));
				} else {
					self.errors.push("Could not complete user id query: " + resp.error.message);
				}
			}).finally(function done() {
				self.idsValidated = true;
				if (self.emailsValidated) {
					self.loading = false;
				}
			});
		} else {
			self.idsValidated = true;
		}
	}

	function identifyNonExistentIds(users) {
		for (var i = 0; i < ids.length; i++) {
			var notFound = true;
			for (var j = 0; j < users.length; j++) {
				if (parseInt(ids[i], 10) === users[j].id) {
					notFound = false;
					break;
				}
			}
			if (notFound) {
				self.errors.push("Could not find user with id: " + ids[i]);
			}
		}
	}

	function identifyNonExistentEmails(users) {
		for (var i = 0; i < emails.length; i++) {
			var notFound = true;
			for (var j = 0; j < users.length; j++) {
				if (emails[i] === users[j].email[0]) {
					notFound = false;
					break;
				}
			}
			if (notFound) {
				self.errors.push("Could not find user with email: " + emails[i]);
			}
		}
	}

	function incrementValidationCounter() {
		rowValidationCounter++;
		if (rowValidationCounter === numberOfRows) {
			getUsers();
		}
	}

	function addUsers(users) {
		for (var i = 0; i < users.length; i++) {
			if (!userInList(users[i].id)) {
				self.users.push(users[i]);
			}
		}
	}

	function emailOrIdInList(emailOrId) {
		for (var i = 0; i < ids.length; i++) {
			if (ids[i] === emailOrId) {
				return true;
			}
		}

		for (var j = 0; j < ids.length; j++) {
			if (emails[j] === emailOrId) {
				return true;
			}
		}

		return false;
	}

	function userInList(id) {
		for (var i = 0; i < self.users.length; i++) {
			if (self.users[i].id === id) {
				return true;
			}
		}

		return false;
	}

	function isNumber(string) {
		return /^\d+$/.test(string);
	}

	function isEmail(string) {
		return validationService.isEmailValid(string.trim());
	}
});
